<template lang="pug">
	v-card
		v-dialog(v-model='dialog' max-width='320')
			v-card.padding
				v-card-title.headline Adicionar p&aacute;gina
				v-text-field(label='nome' v-model='pagina.nome' color='blue-grey')
				v-text-field(label='rota' v-model='pagina.rota' color='blue-grey')
				v-text-field(label='icon' v-model='pagina.icon' color='blue-grey')
				small O que poder&aacute; ser feito nessa p&aacute;gina?
				v-spacer

				input(type='checkbox' v-model='pagina.consultar')
				label Consultar
				v-spacer

				input(type='checkbox' v-model='pagina.incluir')
				label Incluir
				v-spacer

				input(type='checkbox' v-model='pagina.editar')
				label Editar
				v-spacer

				input(type='checkbox' v-model='pagina.excluir')
				label Excluir

				v-card-actions
					v-spacer
					v-btn(color='red darken-2' flat='flat' @click='dialog=false' round dark) Cancelar
					v-btn(color='red darken-2' flat='flat' @click='save' round dark) Adicionar

		v-btn.white--text(color='red darken-2' :disabled='false' @click='dialog=true') Adicionar
		h1.red--text(style='margin:2% 0 0 2%') P&aacute;ginas do Administrador
		p(style='margin:0 0 5% 2%') S&atilde;o rotas (p&aacute;ginas, servi&ccedil;os) que o administrador poder&aacute; configurar permiss&otilde;es

		div(v-for='(p, i) in $store.getters.getPaginasAdmin' :key='i')
			v-divider
			v-list-tile
			v-list-tile-content
				v-list-tile-title
					strong Nome:
					|   {{p.nome}}

				v-list-tile-sub-title
					strong Rota:
					|  {{p.rota}}
			div(style='display:flex;align-items:center;height:100%;')
				label.mychips(v-if='p.consultar == 1')  consultar
				label.mychips(v-if='p.incluir == 1')  Incluir
				label.mychips(v-if='p.editar == 1')  editar
				label.mychips(v-if='p.excluir == 1')  excluir
			v-btn(color='error' @click='trash(p.id)' :disabled='false' :title='p.id' round dark) Remover

</template>


<script>
  import {mapActions} from 'vuex'

  export default {
    data()
    {
      return{
        dialog:false,
        pagina:{
          nome:'',
          rota:'',
          icon:'',
          consultar:false,
          incluir:false,
          editar:false,
          excluir:false
        }
      }
    },
    mounted()
    {
      //carregar páginas do admin
    },
    methods:{
      trash(id)
      {
        if(confirm("tem certeza mesmo?"))
        {
          alert("falta configurar action para exclusão")
        }
      },
      save()
      {
        if(!this.pagina.consultar && !this.pagina.incluir && !this.pagina.editar && !this.pagina.excluir)
        {
          this.$eventHub.emit('snackBar', "Habilite uma ação para esta página!")
          return
        }

        let pagina       = Object.assign({}, this.pagina)
        pagina.rota      = pagina.rota.replace(/( )+/g, '')
        pagina.consultar = (pagina.consultar == true) ? 1 : 2,
        pagina.incluir   = (pagina.incluir == true) ? 1 : 2,
        pagina.editar    = (pagina.editar == true) ? 1 : 2,
        pagina.excluir   = (pagina.excluir == true) ? 1 : 2

        //salva no banco
        alert("falta configurar action para inserção")
        this.dialog=false
      }
    }
  }
</script>


<style>
  .mychips{
    background-color:#ccc !important;
    height:16px;
    width:55px;
    border-radius:2px;
    margin-right:5px;
    font-size:.7em;
    display:flex;
    align-items:center;
    justify-content: center;
  }
</style>






// WEBPACK FOOTER //
// src/components/root/GerenciarRotas.vue